module.exports = __webpack_public_path__ + "img/search.fda44480.svg";